export const trackUserEvent = params => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(params);
};
